<template>
  <div class="submit-button" :class="isLoading">
    <AppTooltip :active="showMessage" :message="tooltipMessage">
      <template #tooltip-handler>
        <div class="submit-button__wrapper">
          <AppButton v-on="$listeners" v-bind="$attrs">
            <Spinner v-if="loading" :size="spinnerSize" />
            <template v-else>
              <slot />
            </template>
          </AppButton>
        </div>
      </template>
    </AppTooltip>
  </div>
</template>

<script>
// Components
import Spinner from 'Ui/AppSpinner'
import AppButton from 'Ui/AppButton'
import AppTooltip from 'Ui/AppTooltip'

export default {
  name: 'SubmitButtonSlot',

  inheritAttrs: false,

  components: {
    Spinner,
    AppTooltip,
    AppButton,
  },

  props: {
    loading: {
      type: Boolean,
      default: false,
    },

    className: {
      type: String,
      default: '',
    },

    showMessage: {
      type: Boolean,
      default: false,
    },

    tooltipMessage: {
      type: String,
      default: '',
    },

    spinnerSize: {
      type: [String, Number],
      default: 25,
    },
  },

  methods: {
    hoverEvent(event) {
      this.$emit('hoverEvent', event)
    },
  },

  computed: {
    isLoading() {
      return this.loading && 'loading'
    },
  },
}
</script>

<style>
.submit-button {
  position: relative;
  width: 152px;
}

.submit-button.disabled {
  cursor: not-allowed;
  pointer-events: all;
}

.submit-button .diy-tooltip {
  display: block;
}

.submit-button.loading {
  cursor: wait;
  pointer-events: all;
}

.submit-button .app-button {
  width: 100%;
}

.submit-button.disabled .app-button,
.submit-button.loading .app-button {
  pointer-events: none;
}
</style>
